export default __webpack_public_path__ + "f81a779d053eb6cb15fc26c7134fec2d.svg";